import { render, staticRenderFns } from "./SearchOwner.vue?vue&type=template&id=b64bbb98&scoped=true"
import script from "./SearchOwner.vue?vue&type=script&lang=js"
export * from "./SearchOwner.vue?vue&type=script&lang=js"
import style0 from "./SearchOwner.vue?vue&type=style&index=0&id=b64bbb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64bbb98",
  null
  
)

export default component.exports